<template>
  <div>
    <q-ajax-bar ref="bar" position="top" color="red-4" size="3px" skip-hijack></q-ajax-bar>
    <div class="row justify-between">
      <q-btn class="justify-center q-ma-xs q-pr-md" ripple dense flat color="black" to="/">
        <q-icon name='arrow_left' style="font-size:2.5em"></q-icon> Quay lại
      </q-btn>
    </div>
    <q-card class="row q-my-xs">
      <div class="col-12 q-pa-md">
        <div class="text-h5 text-center q-py-xs">Bảng chấm công</div>
      </div>
      <div class="col-xs-12 col-sm-8 col-lg-5 q-pa-md row">
        <q-select class="col-12 col-sm q-mx-xs"
          emit-value
          v-model="modelForShow.user"
          clearable
          :use-input="modelForShow.user === null"
          @filter="filterUser"
          :options="userOptions"
          option-value="id"
          option-label="displayName"
          :display-value="$getNameById(mekaStore.list, modelForShow.user, 'displayName')"
          label="Nhân công">
          <template v-slot:prepend>
            <q-icon name="person" />
          </template>
            <template v-slot:append>
              <q-icon v-show="modelForShow.user === null" name="search" />
            </template>
            <template v-slot:no-option>
              <q-item>
                <q-item-section class="text-grey">
                  Không tìm thấy
                </q-item-section>
              </q-item>
            </template>
        </q-select>
        <div class="col q-mx-xs">
          <div class="row justify-between">
              <q-input class="col-11" flat readonly v-model="filterDate">
                <template v-slot:append>
                </template>
              </q-input>
              <q-icon name="event" class="cursor-pointer col-1 self-center" size="32px">
                <q-popup-proxy d ref="qDateProxy" transition-show="scale" transition-hide="scale">
                  <q-date flat v-model="filterDate" mask="DD/MM/YYYY" minimal @input="() => $refs.qDateProxy.hide()" />
                </q-popup-proxy>
              </q-icon>
            </div>
        </div>
      </div>
    </q-card>
    <q-table
      :data="filterdReports"
      :columns="headers"
      row-key="name"
      no-data-label="Không có dữ liệu"
      :key="tableKey"
      :loading='loading'
      :pagination.sync = pagination
      :hide-bottom="!_.isEmpty(filterdReports)"
      >
      <template v-slot:body ="props">
        <q-tr :props="props">
          <q-td class="label-xs-right text-center">{{ props.row.__index+1 }}</q-td>
          <q-td v-if="props.colsMap.date" class="label-xs-right text-center">{{props.row.date instanceof firebase().firestore.Timestamp === true ? moment((props.row.date).toDate()).format('DD/MM/YYYY'): props.row.date }}</q-td>
          <q-td v-if="props.colsMap.meka" class="label-xs-right text-center">{{ (props.row.worker && props.row.worker.meka) ? $getNameById(mekaStore.list, props.row.worker.meka, 'displayName') : ''}}</q-td>
          <q-td v-if="props.colsMap.farm" class="label-xs-right text-center">{{ props.row.farm ? $getNameById(farmStore.list, props.row.farm, 'name') : ''}}</q-td>
          <q-td v-if="props.colsMap.lot" class="label-xs-right text-center">{{ props.row.lot}}</q-td>
          <q-td v-if="props.colsMap.job" class="label-xs-right text-center">{{ props.row.job ? $getNameById(jobStore.list, props.row.job, 'name') : ''}}</q-td>
          <q-td v-if="props.colsMap.totalWeight" class="label-xs-right text-center">{{ props.row.totalWeight}}</q-td>
          <q-td v-if="props.colsMap.unit" class="label-xs-right text-center">{{props.row.job ? $getNameById(jobStore.list, props.row.job, 'unit') : ''}}</q-td>
          <q-td v-if="props.colsMap.supervisor" class="label-xs-right text-center">{{ props.row.supervisor }}</q-td>
        </q-tr>
      </template>
      </q-table>
  </div>
</template>

<script>
/* eslint-disable no-unused-lets */
import moment from "moment"
import { mapGetters } from 'vuex'
import firebase from '@firebase/app'
import {date} from 'quasar'

export default {
  props: [
    "timekeeping",
  ],
  data() {
    return {
      pagination: {
        rowsPerPage: 0,
        },
      reports: null,
      filterdR: [],
      tableKey: 0,
      selectedRowIndex: null,
      loading: true,
      filterDate: date.formatDate(new Date(), 'DD/MM/YYYY'),
      headers: [{
        label: "No",
        align: "center",
        name: "no",
        },
        {
        label: "Ngày",
        align: "center",
        name: "date",
        field: 'date',
        sortable: true,
        },
        {
        label: "Nhân công",
        align: "center",
        name: "meka",
        },
        {
        label: "Nông trường",
        align: "center",
        name: "farm",
        },
        {
        label: "Lô",
        align: "center",
        name: "lot",
        },
        {
        label: "Nội dung CV",
        align: "center",
        name: "job",
        },
        {
        label: "Khối lượng",
        align: "center",
        name: "totalWeight",
        },
        {
        label: "Đơn vị tính",
        align: "center",
        name: "unit",
        },
        ],
      dialogEdit: false,
      monthPopUp: false,
      yearPopUp: false,
      userOptions: [],
      optionsreports: [],
      farms: [],
      modelForShow: {
        user: null
      },
      lot: [],
      harvest: [],
      }
  },
  async mounted() {
    let vm = this
    vm.$nextTick(() => {
      vm.$refs.bar ? vm.$refs.bar.start() : null
      vm.loading = true
    })
    vm.users = await vm.$query(['Masterdata', 'Meka'])
    vm.users = vm._.cloneDeep(vm.users.list).sort((a,b) => a.displayName.localeCompare(b.displayName))
    let rp = vm.fetchData('Reports')
    Promise.all([rp]).then(res => {
      vm.reports = vm._.cloneDeep(vm._.concat(res[0]))
      vm.loading = false
    })
    vm.$refs.bar ? vm.$refs.bar.stop() : null
  },
  watch: {
    'filterDate': {
      // eslint-disable-next-line
      handler: function(newVl, oldVl) {
        let newVal = moment.utc(newVl,'DD/MM/YYYY').format('YYYYMM')
        let oldVal = moment.utc(oldVl,'DD/MM/YYYY').format('YYYYMM')
        if (newVal !== oldVal) {
          this.loading = true
          let lot = this.fetchData('Reports')
          Promise.all([lot]).then(res => {
            this.reports = this._.cloneDeep(this._.concat(res[0]))
            this.filterdR = this.filterdR
            this.loading = false
          })
        }
      },
    deep: true
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'permission',
      'isAnonymous',
      'farmStore',
      'mekaStore',
      'jobStore'
    ]),
  filterdReports: function () {
    let vm = this
    if (!vm.reports) return []
    if (!vm.modelForShow.user) vm.filterdR = vm.reports.filter(v => moment(v.date.toDate()).format('DD/MM/YYYY') === vm.filterDate)
    else vm.filterdR = vm.reports.filter(v => v.worker && v.worker.meka && v.worker.meka && v.worker.meka.indexOf(vm.modelForShow.user) > -1)

    return vm.filterdR.sort((a,b) => b.date.seconds - a.date.seconds === 0 ? 
    vm.$getNameById(vm.mekaStore.list, a.worker.meka, 'displayName').localeCompare(vm.$getNameById(vm.mekaStore.list, b.worker.meka, 'displayName')) === 0 ?
    a.farm === b.farm ? a.lot - b.lot : a.farm - b.farm :
    vm.$getNameById(vm.mekaStore.list, a.worker.meka, 'displayName').localeCompare(vm.$getNameById(vm.mekaStore.list, b.worker.meka, 'displayName'))
    : b.date.seconds - a.date.seconds)
    }
  },
  methods: {
    fetchData(collection) {
      const regexFarm = /(^F[0-9]M$)/
      let roles = this.permission.roles
      return this.$query([collection], [['deleted','==', false],['yearMonth', '==', moment.utc(this.filterDate,'DD/MM/YYYY').format('YYYYMM')]]).then(data => {
        if(this.permission.roles.hasOwnProperty('BOM')) {
          return data.data
        } else {
          let fm = Object.keys(roles).filter((item) => regexFarm.test(item)).map(i => parseInt(i[1]))
          let filter = []
          data.data.forEach(item => {
            if(item.supervisor === this.user.email || fm.indexOf(item.farm) !== -1) {
              filter.push(item)
            }
          })
        return filter ? filter : []
        }
      })
    },
    // eslint-disable-next-line
    filterUser(val, update, abort) {
      let vm = this
      update(() => {
        if (val === '') {
          this.userOptions = vm.users
        }
        else {
          const needle = val.toLowerCase()
          this.userOptions = vm.users.filter(v => v.displayName ? v.displayName.toLowerCase().indexOf(needle) > -1 : -1)
        }
      })
    },
    moment(timestamp) {
      return moment(timestamp)
    },
    firebase() {
      return firebase
    }
  }
}
</script>

